function detect(pattern) {
  return () => {
    return pattern.test((window.navigator && navigator.userAgent) || '')
  }
}

/**
 * ua 验证
 *
 * @module ua
 */

export default {
  /**
   * chrome
   *
   * @function
   * @returns {boolean}
   */
  isChrome: detect(/webkit\W.*(chrome|chromium)\W/i),

  /**
   * firefox
   *
   * @function
   * @returns {boolean}
   */
  isFirefox: detect(/mozilla.*\Wfirefox\W/i),

  /**
   * 使用 gecko 引擎的浏览器，可能是 firefox 也可能是其他的
   *
   * @function
   * @returns {boolean}
   */
  isGecko: detect(/mozilla(?!.*webkit).*\Wgecko\W/i),

  /**
   * IE
   *
   * @function
   * @returns {boolean}
   */
  isIE: function () {
    if (navigator.appName === 'Microsoft Internet Explorer') return true
    else if (detect(/\bTrident\b/)) return true

    return false
  },

  /**
   * kindle
   *
   * @function
   * @returns {boolean}
   */
  isKindle: detect(/\W(kindle|silk)\W/i),

  /**
   * mobile
   *
   * @function
   * @returns {boolean}
   */
  isMobile: detect(/(iphone|ipod|((?:android)?.*?mobile)|blackberry|nokia)/i),

  /**
   * opera
   *
   * @function
   * @returns {boolean}
   */
  isOpera: detect(/opera.*\Wpresto\W|OPR/i),

  /**
   * safari，注：QQ 浏览器、chrome 浏览器都带有 safari 标示
   *
   * @function
   * @returns {boolean}
   */
  isSafari: detect(/webkit\W(?!.*chrome).*safari\W/i),

  /**
   * 平板
   *
   * @function
   * @returns {boolean}
   */
  isTablet: detect(/(ipad|android(?!.*mobile)|tablet)/i),

  /**
   * tv
   *
   * @function
   * @returns {boolean}
   */
  isTV: detect(/googletv|sonydtv|appletv/i),

  /**
   * webkit
   *
   * @function
   * @returns {boolean}
   */
  isWebKit: detect(/webkit\W/i),

  /**
   * android
   *
   * @function
   * @returns {boolean}
   */
  isAndroid: detect(/android/i),

  /**
   * ios
   *
   * @function
   * @returns {boolean}
   */
  isIOS: detect(/(ipad|iphone|ipod)/i),

  /**
   * ipad
   *
   * @function
   * @returns {boolean}
   */
  isIPad: detect(/ipad/i),

  /**
   * iphone
   *
   * @function
   * @returns {boolean}
   */
  isIPhone: detect(/iphone/i),

  /**
   * ipod
   *
   * @function
   * @returns {boolean}
   */
  isIPod: detect(/ipod/i),

  /**
   * 手机 QQ 浏览器
   *
   * @function
   * @returns {boolean}
   */
  isMQQ: detect(/mqqbrowser/i),

  /**
   * QQ 浏览器
   *
   * @function
   * @returns {boolean}
   */
  isQQ: detect(/qqbrowser/i),

  /**
   * QQ 内置浏览器
   *
   * @function
   * @returns {boolean}
   */
  isIMQQ: detect(/\bQQ\b/i),

  /**
   * UC 浏览器
   *
   * @function
   * @returns {boolean}
   */
  isUC: detect(/uc browser|ucbrowser|ucweb/i),

  /**
   * 360 浏览器
   *
   * @function
   * @returns {boolean}
   */
  is360: detect(/qhbrowser|360(.+)browser/i),

  /**
   * 微信浏览器
   *
   * @function
   * @returns {boolean}
   */
  isWechat: detect(/micromessenger/i),

  /**
   * 百度浏览器
   *
   * @function
   * @returns {boolean}
   */
  isBaidu: detect(/baidubrowser|flyflow/i),

  /**
   * 猎豹浏览器
   *
   * @function
   * @returns {boolean}
   */
  isLiebao: detect(/liebao/i),

  /**
   * 搜狗浏览器
   *
   * @function
   * @returns {boolean}
   */
  isSogou: detect(/sogou|metasr/i),

  /**
   * 傲游浏览器
   *
   * @function
   * @returns {boolean}
   */
  isMaxthon: detect(/maxthon/i),

  /**
   * 小米浏览器
   *
   * @function
   * @returns {boolean}
   */
  isXiaoMi: detect(/XiaoMi/i),

  /**
   * 是否 oppo
   * @function
   * @returns {boolean}
   */
  isOppo: detect(/OPPO|PACT00|PACM00|PAAT00|PAAM00|PADM00|PADT00/i),

  /**
   * 是否是华为
   * @function
   * @returns {boolean}
   */
  isHuawei: detect(/huawei|honor/i),
  /**
   * ua
   *
   * @function
   * @returns {string}
   */
  whoami() {
    return (window.navigator && navigator.userAgent) || ''
  },
  checkIsMobile() {
    return navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    )
  },
}
